import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LocaleProvider } from "@/context/locale-context";
import { CartProvider } from "@/context/cart-context";
import { Layout } from "@/components/layout";
import Home from "@/pages/home";
import Gallery from "@/pages/gallery";
import PaintingDetail from "@/pages/painting-detail";
import AdminDashboard from "@/pages/admin";
import AdminLogin from "@/pages/admin-login";
import Checkout, { CheckoutBoldReturn, CheckoutBoldCancel } from "@/pages/checkout"; // 👈 actualizado a Bold
import NotFound from "@/pages/not-found";
import ArtistProfile from "@/pages/ArtistProfile";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPages";


const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});


function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <LocaleProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
  <Route path="/"                      element={<Layout><Home /></Layout>}               />
  <Route path="/gallery"               element={<Layout><Gallery /></Layout>}            />
  <Route path="/painting/:id"          element={<Layout><PaintingDetail /></Layout>}     />
  <Route path="/checkout"              element={<Layout><Checkout /></Layout>}           />
  <Route path="/checkout/bold-return"  element={<Layout><CheckoutBoldReturn /></Layout>} />
  <Route path="/checkout/bold-cancel"  element={<Layout><CheckoutBoldCancel /></Layout>} />
  <Route path="/artist"                element={<Layout><ArtistProfile /></Layout>}      />
  <Route path="/contact"               element={<Layout><Contact /></Layout>}            />
  <Route path="/legal"                 element={<Layout><LegalPage /></Layout>}           />
  <Route path="/legal/privacy"          element={<Layout><LegalPage /></Layout>}           />
  <Route path="/legal/terms"            element={<Layout><LegalPage /></Layout>}           />
  <Route path="/legal/cookies"          element={<Layout><LegalPage /></Layout>}           />
  <Route path="/legal/shipping-returns" element={<Layout><LegalPage /></Layout>}           />
  <Route path="/admin/login"           element={<AdminLogin />}                          />
  <Route path="/admin"                 element={<AdminDashboard />}                      />
  <Route path="*"                      element={<NotFound />}                            />
</Routes>
            </BrowserRouter>
            <Toaster />
          </CartProvider>
        </LocaleProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}


export default App;